import { useState } from 'react';
import * as XLSX from 'xlsx';
import { processExcelData, validateExcelFile } from '../utils/excelProcessor';

/**
 * Hook para gerenciar upload e processamento de arquivos Excel
 */
export const useFileUpload = () => {
  const [loading, setLoading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const handleFileUpload = async (file, onSuccess) => {
    if (!file) return;

    if (!validateExcelFile(file)) {
      setUploadError('Por favor, selecione um arquivo Excel (.xlsx ou .xls)');
      return;
    }

    try {
      setLoading(true);
      setUploadError(null);
      
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { 
            type: 'array',
            cellDates: true
          });
          
          let sheetName = 'Tabela 1';
          if (!workbook.Sheets[sheetName]) {
            sheetName = workbook.SheetNames[0];
          }
          
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
            header: 1,
            defval: null,
            blankrows: false
          });
          
          if (jsonData.length < 2) {
            throw new Error('A planilha deve conter pelo menos um cabeçalho e uma linha de dados');
          }
          
          const processedData = processExcelData(jsonData);
          
          if (processedData.length === 0) {
            throw new Error('Nenhum dado válido foi encontrado na planilha');
          }
          
          setLoading(false);
          onSuccess(processedData);
          
        } catch (error) {
          setUploadError(`Erro ao processar arquivo: ${error.message}`);
          setLoading(false);
        }
      };
      
      reader.readAsArrayBuffer(file);
    } catch (error) {
      setUploadError(`Erro ao fazer upload: ${error.message}`);
      setLoading(false);
    }
  };

  return {
    loading,
    uploadError,
    handleFileUpload,
    setUploadError
  };
};
